/* global bassAdIntervals */

/**
 * Core global JS.
 */

// Components
import { ComponentManager } from 'js-component-framework';
import headerConfig from '../../components/header';
import subscriptionConfig from '../../components/subscription-form';

// Helpers
import initAdRefresh from './adRefreshLogic';

// Create instance of the component manager using `bassmaster-theme`
const manager = new ComponentManager('bassmaster-theme');

document.addEventListener('DOMContentLoaded', () => {
  // Initialize components.
  // You can supply an array of configurations to start many components at once.
  manager.initComponents([
    headerConfig,
    subscriptionConfig,
  ]);

  // Localize global variables.
  const { postInterval } = bassAdIntervals;
  const { googletag } = window;

  initAdRefresh(postInterval, googletag);
});

if (module.hot) {
  module.hot.accept();
  // This is required for HMR, otherwise you'll need to refresh
  // the page to see JS changes
  manager.initComponents([
    headerConfig,
    subscriptionConfig,
  ]);
}
